import enquire from 'enquire.js'
import { overlayAdd, overlayRemove } from '../overlay/overlay'

const $hamburger = document.querySelector('.hamburger--js')
const $mainmenu = document.querySelector('.mainmenu--js')
const $mainmenuItems = document.querySelectorAll('.mainmenu--js  .scroll-link')
const $closeBtn = document.querySelector('.mainmenu--close')

function showMenu() {
	$mainmenu.classList.add('is-active')
	$hamburger.classList.add('is-active')
	document.body.style.overflowY = 'hidden'
	document.body.style.height = '100vh'
	//overlayAdd(150)
}

function hideMenu() {
	$mainmenu.classList.remove('is-active')
	$hamburger.classList.remove('is-active')
	document.body.style.overflowY = 'scroll'
	document.body.style.height = '100%'
	//overlayRemove()
}

$mainmenuItems.forEach((item) => {
	item.addEventListener('click', () => {
		setTimeout(hideMenu, 200)
	})
})

const clickHandler = event => {
	event.preventDefault()

	if ($mainmenu.classList.contains('is-active')) {
		hideMenu()
	} else {
		showMenu()
	}
}

enquire.register('screen', {
	// deferSetup: true,
	match() {
		$hamburger.addEventListener('click', clickHandler)
		document.addEventListener('click', event => {
			if (event.target.dataset.backdrop === 'overlay') {
				hideMenu()
			}
		})
		$closeBtn.addEventListener('click', hideMenu)
	},
	unmatch() {
		$hamburger.removeEventListener('click', clickHandler)
		$closeBtn.removeEventListener('click', hideMenu)
	}
})

enquire.register('screen and (max-width: 991.98px)', {
	// deferSetup: true,
	match() {
		$hamburger.addEventListener('click', overlayAdd)
		$closeBtn.addEventListener('click', overlayRemove)
	},
	unmatch() {
		$hamburger.removeEventListener('click', overlayAdd)
		$closeBtn.removeEventListener('click', overlayRemove)
	}
})
